import { copyTextToClipboard } from "@/utils/clipboardUtils";
import { showClipboardCopyFeedback } from "@/utils/clipboardFeedbackUtils";

/**
 * Добавляет к toast-уведомлению тихое копирование текста по клику.
 */
export function copyableToastOptions(message, options = {}) {
  const originalOnClick = options.onClick;

  return {
    ...options,
    onClick: async (...args) => {
      const copied = await copyTextToClipboard(message).catch(() => false);

      if (copied) showClipboardCopyFeedback();
      if (originalOnClick) originalOnClick(...args);
    },
  };
}
